// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsIndicatorsAddForm_heading__z7TU3","form":"ReportingDetailsIndicatorsAddForm_form__9DCNU"};